let API = 'http://videotool.fancyapi.com/'
export default {
	API
}
